import React from 'react'
import { observer } from 'mobx-react'

import NumberFormat from 'react-number-format'

export const MoneyView = observer(({value}) =>
  <NumberFormat value={value} suffix=" €" displayType="text" thousandSeparator=" " decimalSeparator="," fixedDecimalScale decimalScale={2} />)
